import React, { useState } from "react";
import styled from "@emotion/styled";
import Prism from "prismjs";
import CodePanel from "./CodePanel";

export default function CodeSlideshow({ codePages }) {
  const [activePanelName, setActivePanelName] = useState("");
  if (!codePages) return null
  return (
    <Container>
      <SlideShow>
        {codePages.map(page => (
          <CodePanel
            code={page.fields.code}
            title={page.fields.title}
            activePanelName={activePanelName}
            setActivePanelName={setActivePanelName}
          />
        ))}
      </SlideShow>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  &::after {
    content: "click panel to expand";
    position: absolute;
    top: -1.8em;
    left: 0;
    color: grey;
    opacity: 0.7;
  }
`;

const SlideShow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
`;
